import clsx from 'clsx';
import React , {useEffect } from 'react';
import ProjectsTable from "../HomePage/ProjectsTable/ProjectsTable";
import apiService from '../../services/apiService';

// This component is used to display user's personal info
const PersonalInfo = ( props ) => {

    const {
        state,
        dispatch
    } = props;

    const [init,setInit] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [updateData, setUpdateData] = React.useState(false);

    useEffect(() => {
        if (init === false) {
          setInit(true);
        }
    }, [init]);

    // This useEffect is used to get user's data
    useEffect(() => {

        if (state.isLoggedIn && init === true) {
         
            apiService
            .getUsersProjects(state.user._id)
            .then((response) => { 
              setData(response.data);
              localStorage.setItem('data', JSON.stringify(response.data));
            })
            .catch((err) => {
              if (err.message === 'authentication failed') {
                dispatch({ type: 'LOGOUT' });
              }
            });
        }
        setUpdateData(false);
    }, [dispatch, state, updateData, init]);

    return(
            <div className={clsx('generalMarg', 'spacingTop')}  >
                <div style ={{display: 'flex', flexDirection: 'column'}}>
                    <ImageUser 
                        state = {state}
                    />
                    <UserName 
                        state = {state}
                    />
                    <Email 
                        state = {state}
                    />
                    <Projects 
                        data = {data}
                        setUpdateData = {setUpdateData}
                        updateData = {updateData}
                    />
                </div>
            </div>
    )

}

// This component is used to render user's image logo from GitHub
const ImageUser = ({state}) => 
    (
        <div style={{display: 'flex', marginTop: '2rem'}}>
            <span style={{ minWidth:'10rem'}}/>
            <img
                src={state.user.git_image_user || '/images/General/User.png'}
                alt="user_logo"
                id= 'userLogo'
                style={{ width: "4rem", borderRadius: "10%" }}
            />
        </div>
    )

// This component is used to render user's login name
const UserName = ({state}) =>
    (
        <div style={{display: 'flex', marginTop: '1rem'}}>
            <span style={{ minWidth:'10rem'}} className={clsx('boldBlue')}>Username:</span>
            <span id='userLoginName'>{state.user.login}</span>
        </div>
    )

// This component is used to render user's email
const Email = ({state}) => 
    (
        <div style={{display: 'flex', marginTop: '1rem'}}>
            <span style={{ minWidth:'10rem'}} className={clsx('boldBlue')}>Email:</span>
            <span id='userEmail'>{state.user.email}</span>
        </div>
    )


// This component is used to render user's projects
const Projects = ({data, setUpdateData, updateData}) => 
    (
        <span style ={{marginTop: '1rem'}}> 
            <span style= {{ display: 'flex', marginBottom: '1rem'}} className={clsx('boldBlue')}> Projects: </span>
            <ProjectsTable
                data={data}
                moveBuildApps={() => {}}
                setUpdateData={setUpdateData}
                updateData={updateData}
            />
        </span>
    )

export default PersonalInfo;